module.exports = __webpack_public_path__ + "static/_/src/config/PsMusicConfig/musics/cd1//Track_16_It_s My Mummy.mp3";